"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// React
const react_1 = require("react");
// Redux
const react_redux_1 = require("react-redux");
const nprogress_1 = __importDefault(require("nprogress"));
// Next
const router_1 = require("next/router");
// Utils
const next12_utils_ping_cms_page_1 = __importDefault(require("@gcloud-npm/next12.utils.ping-cms-page"));
const utils_1 = require("./utils");
let interval = null;
let auxData = null;
const RouteHandler = ({ setContextData }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const CONTEXT = (0, react_redux_1.useSelector)((state) => state.main.context);
    const enviaPingMemo = (0, react_1.useCallback)(() => {
        let ping = new next12_utils_ping_cms_page_1.default({ context: CONTEXT });
        ping.sendPingCmsPage();
        ping = null;
    }, [CONTEXT]);
    const router = (0, router_1.useRouter)();
    const [contextPageInfo, setContextPageInfo] = (0, react_1.useState)(null);
    const [lastPageName, setLastPageName] = (0, react_1.useState)("");
    const [lastPageId, setLastPageId] = (0, react_1.useState)(null);
    const [lastContextPageInfo, setLastContextPageInfo] = (0, react_1.useState)(null);
    const [pagePrinted, setPagePrinted] = (0, react_1.useState)(false);
    const PAGE_DATA = (0, react_redux_1.useSelector)((state) => {
        return {
            contextSeoMeta: state.main.currentSeo && state.main.currentSeo.description,
            pageName: state.main.currentSeo && state.main.currentSeo.page_name,
            productName: state.main.currentSeo && state.main.currentSeo.product_name,
        };
    });
    const pageID = (0, react_redux_1.useSelector)((state) => {
        return ((state.main.context &&
            state.main.context.clientIDs &&
            state.main.context.clientIDs.pageId) ||
            null);
    });
    (0, react_1.useEffect)(() => {
        console.log("DEBUG 1 RH");
        let retries = 50;
        interval = setInterval(() => {
            var _a;
            // Suscripción a context para persistirlo en redux.
            (_a = window.nookInfoExchange) === null || _a === void 0 ? void 0 : _a.registerAsObserver("Context", "app", (data) => {
                dispatch(setContextData(data));
            });
            (0, utils_1.mapContextParamsToPageEvent)("Router", (data) => {
                retries = 0;
                auxData = data;
                setContextPageInfo(data);
            });
            retries = retries - 1;
            if (retries <= 0) {
                if (auxData) {
                    setContextPageInfo(Object.assign({}, auxData));
                }
                clearInterval(interval);
            }
        }, 250);
    }, []);
    (0, react_1.useEffect)(() => {
        // console.log('DEBUG 2 RH');
        const handleRouteChangeStart = (url, { shallow }) => {
            nprogress_1.default.start();
            // console.log("Start cambio ruta");
        };
        const handleRouteChangeComplete = (url, { shallow }) => {
            var _a;
            // console.log("Complete cambio ruta");
            (_a = window.nookInfoExchange) === null || _a === void 0 ? void 0 : _a.sendMessage("SPA-Location", {});
            nprogress_1.default.done();
        };
        router.events.on("routeChangeStart", handleRouteChangeStart);
        router.events.on("routeChangeComplete", handleRouteChangeComplete);
        return () => {
            router.events.off("routeChangeStart", handleRouteChangeStart);
            router.events.off("routeChangeComplete", handleRouteChangeComplete);
        };
    }, [router.events]);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        // console.log('DEBUG 3 RH');
        // Este es el que me interesa.
        // Si el pageName de ahora es distinto al de antes, mando pageView
        if (contextPageInfo) {
            if (lastPageName !== PAGE_DATA.pageName &&
                lastPageId !== pageID &&
                (lastContextPageInfo === null ||
                    lastContextPageInfo["context-page-id"] !==
                        contextPageInfo["context-page-id"])) {
                setLastPageName(PAGE_DATA.pageName);
                setLastPageId(pageID);
                setLastContextPageInfo(contextPageInfo);
                enviaPingMemo();
                // SendPageView
                const data2send = Object.assign(Object.assign({}, (0, utils_1.buildViewData)(contextPageInfo)), { event: "cms-page", "event-type": "view", "context-seo-meta": PAGE_DATA.contextSeoMeta, "page-name": PAGE_DATA.pageName, "page-product-name": PAGE_DATA.productName, "context-url": document.location.href });
                setPagePrinted(false);
                (_a = window.nookInfoExchange) === null || _a === void 0 ? void 0 : _a.sendMessage("Metrics", data2send);
            }
            if (!pagePrinted && contextPageInfo["event-type"] === "loaded") {
                const data2send = Object.assign(Object.assign({}, (0, utils_1.buildViewData)(contextPageInfo)), { event: "cms-page", "event-type": "printed", "context-seo-meta": PAGE_DATA.contextSeoMeta, "page-name": PAGE_DATA.pageName, "page-product-name": PAGE_DATA.productName, "context-url": document.location.href });
                (_b = window.nookInfoExchange) === null || _b === void 0 ? void 0 : _b.sendMessage("Metrics", data2send);
                setPagePrinted(true);
            }
        }
    }, [
        PAGE_DATA,
        contextPageInfo,
        lastPageName,
        lastContextPageInfo,
        pageID,
        lastPageId,
        pagePrinted,
        CONTEXT,
        enviaPingMemo,
    ]);
    return null;
};
exports.default = RouteHandler;
//# sourceMappingURL=index.js.map